import { render } from "./confirmToLobbyModal.vue?vue&type=template&id=37149468&scoped=true"
import script from "./confirmToLobbyModal.vue?vue&type=script&lang=js"
export * from "./confirmToLobbyModal.vue?vue&type=script&lang=js"

import "./confirmToLobbyModal.vue?vue&type=style&index=0&id=37149468&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37149468"]])

export default __exports__